import { DialogTitle, Grid, Stack } from '@mui/material';
import { ClientContactDTO, IUserDTO, saveClientContact, updateClientContact } from 'wisestep-api';
import {
  WsButton,
  WsDialog,
  WsIconCross,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useUserContext } from '../../../../context';
import { fetchAndSetAssignedUsers } from '../../../../features/users/helper/hooks';
import { success, failed, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import ClientContactForm from '../../../clientListingPage/components/clientContactComponents/ClientContactForm';
import { defaultClientContactDTO } from '../../../clientListingPage/helper/ClientListingHelper';

export interface DialogProps {
  open: boolean;
  clientId: string;
  clientName: string;
  clientRecruiterEmailInputVal: string;
  onClose(): void;
  onSelect: (clientContact: ClientContactDTO) => void;
}

const CreateNewClientContactDialog = ({
  open,
  clientId,
  clientRecruiterEmailInputVal,
  onClose,
  onSelect,
  clientName,
}: DialogProps) => {
  const setNotification = useNotificationStore((state) => state.setNotification);
  const loggedInUser = useUserContext().userDTO as IUserDTO;

  const onSubmit = async (data, isShareable) => {
    let response;
    try {
      const allowedRecruiters = isShareable
        ? await fetchAndSetAssignedUsers(loggedInUser.email ?? '')
        : [];
      data.allowedRecruiters = allowedRecruiters;
      response = data.id ? await updateClientContact(data) : await saveClientContact(data);
      onSelect(response.data.data);
      setNotification(success('Client Contact has been saved successfully !!'));
    } catch (error) {
      console.error('Error in onSubmit:', error);
      setNotification(failed('Something went wrong, Please try again !!'));
    }
    return response?.data?.data?.id;
  };
  return (
    <>
      {clientId ? (
        <WsDialog openDialog={open}>
          <DialogTitle>
            <Grid item container justifyContent="space-between">
              <Stack direction="row" spacing={1}>
                <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
                  {`Create Client Contact for `}
                </WsTypography>
                <WsTypography
                  variant={WsTypoVariants.SUB_TITLE}
                  color={WsTypoColors.PRIMARY}
                  bold={true}
                >
                  {clientName}
                </WsTypography>
              </Stack>
              <WsButton startIcon={<WsIconCross />} onClick={onClose} variant="text">
                Close
              </WsButton>
            </Grid>
          </DialogTitle>
          <Grid p={2}>
            <ClientContactForm
              clientId={clientId}
              onSubmit={onSubmit}
              saveButtonLabel="Save"
              clientContact={defaultClientContactDTO(
                clientId,
                clientRecruiterEmailInputVal?.trim()
              )}
              source="JobPostingForm"
            />
          </Grid>
        </WsDialog>
      ) : (
        setNotification(warning('Please re-select client and try again !!'))
      )}
    </>
  );
};

export default CreateNewClientContactDialog;
